import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import { HelperText01 } from 'components/styles';

const ROCKETLANE_URL =
  'https://rocketlane.com/?utm_source=customer_portal&utm_medium=portal_link&utm_campaign=poweredby';

const Link = styled(Button)`
  color: var(--gray-60);
`;

export const PoweredBy = styled.div`
  text-align: center;
  padding: var(--spacing-02) 0;
  ${HelperText01};
`;

const FlashIcon = styled.span.attrs({ role: 'img', 'aria-label': 'powered' })`
  margin-right: var(--spacing-03);
`;

export const Rocketlane = () => (
  <Link type="link" target="_blank" href={ROCKETLANE_URL}>
    {/* eslint-disable-next-line jsx-a11y/accessible-emoji */}
    <FlashIcon>⚡</FlashIcon>
    <FormattedMessage id="by_rocketlane" />
  </Link>
);
